import * as dayjs from 'dayjs';
import { Component, Fragment, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import ReactStars from 'react-stars';
import { AdminApi } from '../admin-api';
import CropPhoto from './CropPhoto';
import Header from './Header';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

import 'react-image-crop/dist/ReactCrop.css';

export default function GoogleReview(props: any): ReactNode {
  return <GoogleReviewComp navigate={useNavigate()} {...props} />;
}

class GoogleReviewComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      list: [],
      newReview: {
        name: '',
        stars: 5,
        description: '',
        photoUrl: undefined,
      },
      isSubmitting: false,
      deleting: [],
    };
  }

  state: Readonly<{
    isLoading: boolean;
    list: any[];
    newReview: {
      name: string;
      stars: number;
      description: string;
      photoUrl?: string;
    } | null;
    isSubmitting: boolean;
    deleting: number[];
  }>;

  async componentDidMount() {
    const _data = await AdminApi.get('/google-reviews');

    this.setState({ list: _data, isLoading: false });
  }

  async createReview() {
    this.setState({ isSubmitting: true });

    const _data = await AdminApi.post('/google-reviews', this.state.newReview);

    this.setState({
      list: [...this.state.list, _data],
      newReview: { name: '', stars: 5, description: '' },
      isSubmitting: false,
    });
  }

  async uploadPhoto(key: string) {
    const _newUrl = await AdminApi.post('/google-reviews/photo-upload', {
      key: key,
    });

    this.setState({
      newReview: { ...this.state.newReview, photoUrl: _newUrl },
    });

    return _newUrl;
  }

  async deleteReview(id: number) {
    this.setState({ deleting: [...this.state.deleting, id] });

    await AdminApi.delete(`/google-reviews/${id}`);

    this.setState({
      list: this.state.list.filter((item) => item.id !== id),
      deleting: this.state.deleting.filter((item) => item !== id),
    });
  }

  oneReview(review?: any): ReactNode {
    return (
      <div
        className={`${review ? 'col-md-4 d-flex align-items-stretch' : 'col-md-6'} mt-3`}
        key={review?.id ?? -1}
      >
        <div className="card">
          <div className="card-body">
            {!review && <h5 className="card-title">Nova Avaliação</h5>}

            {!review && (
              <Fragment>
                <CropPhoto
                  noCard={true}
                  className="img-thumbnail review-photo"
                  cardTitle=""
                  cardHelpText="Foto de do avaliador"
                  onUpload={(key: string) => this.uploadPhoto(key)}
                  onRemove={async () =>
                    this.setState({
                      newReview: {
                        ...this.state.newReview,
                        photoUrl: undefined,
                      },
                    })
                  }
                  uploaded={this.state.newReview?.photoUrl}
                  currentUser={this.props.currentUser}
                  cropProps={{
                    aspect: 1,
                    maxWidth: 500,
                    maxHeight: 500,
                    style: { maxHeight: '700px' },
                    circularCrop: true,
                  }}
                />
                <hr />
              </Fragment>
            )}
            {review ? (
              <div className="d-flex flex-row align-items-center mb-3">
                <div className="me-3">
                  <img
                    src={review.photoUrl || '/assets/img/user.png'}
                    className="img-thumbnail review-photo-small"
                  />
                </div>

                <h5 className="card-title">{review.name}</h5>
              </div>
            ) : (
              <input
                type="text"
                className="form-control mt-3"
                placeholder="Nome da pessoa"
                onChange={(e) => {
                  this.setState({
                    newReview: {
                      ...this.state.newReview,
                      name: e.target.value,
                    },
                  });
                }}
                value={this.state.newReview?.name}
              />
            )}
            {review ? (
              <h6 className="card-subtitle mb-2 text-muted">
                {review.stars} estrelas
              </h6>
            ) : (
              <ReactStars
                className="mt-3"
                count={5}
                value={this.state.newReview?.stars}
                half={false}
                onChange={(val: number) =>
                  this.setState({
                    newReview: {
                      ...this.state.newReview,
                      stars: val,
                    },
                  })
                }
                size={24}
                color2={'#ffd700'}
              />
            )}
            {review ? (
              <p className="card-text">{review.description}</p>
            ) : (
              <textarea
                className="form-control mt-3"
                placeholder="Descrição da avaliação"
                onChange={(e) => {
                  this.setState({
                    newReview: {
                      ...this.state.newReview,
                      description: e.target.value,
                    },
                  });
                }}
                value={this.state.newReview?.description}
              />
            )}
          </div>
          <div className="card-footer">
            {review && (
              <small className="text-muted pull-left">
                {dayjs(review.createdAt).format('DD/MM/YYYY HH:mm')}
              </small>
            )}

            {review ? (
              <button
                className="btn btn-danger pull-right"
                disabled={this.state.deleting.includes(review.id)}
                onClick={() => this.deleteReview(review.id)}
              >
                {this.state.deleting.includes(review.id) ? (
                  <LoadingButton />
                ) : (
                  'Remover'
                )}{' '}
              </button>
            ) : (
              <button
                disabled={
                  !this.state.newReview?.name ||
                  !this.state.newReview?.stars ||
                  !this.state.newReview?.description ||
                  this.state.isSubmitting
                }
                onClick={() => this.createReview()}
                className="btn btn-primary pull-right"
              >
                {this.state.isSubmitting ? <LoadingButton /> : 'Criar'}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="ms-sm-auto large-calendar px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Revisões do Google</h1>
                <div className="btn-toolbar mb-2 mb-md-0"></div>
              </div>
              <div className="row">{this.oneReview()}</div>

              <hr />

              <div className="row mb-5">
                {this.state.list.map((item) => this.oneReview(item))}
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
